import { Card, Grid, Typography, Button, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import { useCallback, useRef, useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { fontsize15, poppins600 } from 'theme/common.style';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function BarChart({ interestedsector1, list }) {
  const [views, setviews] = useState(true);
  const [enquiry, setenquiry] = useState(true);
  const [inspected, setinspected] = useState(true);
  const [interested, setinterested] = useState(true);
  const [offers, setoffers] = useState(true);

  const theme = useTheme();
  const matches500 = useMediaQuery(theme.breakpoints.down(500));

  useEffect(() => {
    list?.length > 0 &&
      list?.map((item) => {
        if (item?.dataset == 'Views') {
          if (item?.visible == true) {
            setviews(true);
          } else {
            setviews(false);
          }
        }
        if (item?.dataset == 'Enquiry') {
          if (item?.visible == true) {
            setenquiry(true);
          } else {
            setenquiry(false);
          }
        }
        if (item?.dataset == 'Inspected') {
          if (item?.visible == true) {
            setinspected(true);
          } else {
            setinspected(false);
          }
        }
        if (item?.dataset == 'Interested') {
          if (item?.visible == true) {
            setinterested(true);
          } else {
            setinterested(false);
          }
        }
        if (item?.dataset == 'Offers') {
          if (item?.visible == true) {
            setoffers(true);
          } else {
            setoffers(false);
          }
        }
      });
  }, [list]);
  const data = {
    labels: [
      views ? 'Views' : null,
      enquiry ? 'Enquiry' : null,
      inspected ? 'Inspected' : null,
      interested ? 'Interested' : null,
      offers ? 'Offers' : null,
    ],
    datasets: [
      {
        label: 'Count',
        axis: 'y',
        data: [
          views ? `${interestedsector1?.rightColumn?.totalView}` : null,
          enquiry ? `${interestedsector1?.rightColumn?.watchCount}` : null,
          inspected
            ? `${interestedsector1?.rightColumn?.inspectedCount}`
            : null,
          interested
            ? `${interestedsector1?.rightColumn?.interestedCount}`
            : null,
          offers ? `${interestedsector1?.rightColumn?.offerCount}` : null,
        ],
        borderColor: [
          'rgb(0, 119, 182)',
          'rgb(3, 4, 94)',
          'rgb(0, 180, 216)',
          'rgb(144, 224, 239)',
          'rgb(153, 102, 255)',
        ],
        // fontSize: matches500 ? "8px" : undefined,
        backgroundColor: [
          'rgba(0, 119, 182,0.2)',
          'rgba(3, 4, 94, 0.2)',
          'rgba(0, 180, 216,0.2)',
          'rgba(144, 224, 239,0.2)',
          'rgba(153, 102, 255, 0.2)',
        ],
        fill: false,
        borderWidth: 1,
      },
    ],
  };
  const options = {
    indexAxis: 'y',
    responsive: true,
    barThickness: 10,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          display: false, // ❌ remove vertical grid lines
          drawBorder: false,
        },
        ticks: {
          display: true, // keep numbers if you want
        },
      },
      y: {
        grid: {
          display: false, // ❌ remove horizontal grid lines
          drawBorder: false,
        },
        ticks: {
          display: true, // keep labels
        },
      },
    },
  };

  const [downloadBarChart, setDownloadBarChart] = useState();
  let ref = useRef(null);

  const DownloadImg = useCallback(() => {
    const link = document.createElement('a');
    link.download = 'BarChart.png';
    link.href = ref.current.toBase64Image();
    setDownloadBarChart(ref.current.toBase64Image());
    // link.click();
  });

  useEffect(() => {
    DownloadImg();
  }, []);

  return (
    <Grid
      sx={{
        display: 'flex',
        paddingTop: '5px',
        minWidth: '100%',
        height: '100%',
      }}
    >
      <Card
        sx={{
          borderRadius: '8px',
          padding: '15px',
          height: '100%',
          boxShadow: 'none',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          backgroundColor: '#fff',
        }}
      >
        <Typography
          sx={{ ...poppins600, fontSize: matches500 ? '12px' : undefined }}
        >
          Conversion Tree
        </Typography>

        {/*  CHART CONTAINER */}
        <Grid
          sx={{
            flex: 1,
            minHeight: 0,
          }}
        >
          <Bar ref={ref} data={data} options={options} />
        </Grid>
      </Card>
    </Grid>
  );
}
export default BarChart;
